// Codekit -->
// @codekit-prepend "global/vars.js"
// @codekit-prepend "utilities/debounce.js"
// @codekit-prepend "utilities/ajax.js"
// @codekit-prepend "utilities/lazy.js"
// @codekit-prepend "components/ticker.js"
// @codekit-prepend "components/planets.js"
// @codekit-prepend "components/overlay.js"

// @codekit-append "global/document-ready.js"
// @codekit-append "global/resize.js"

//<- Codekit

//Funcitons start -->

// const loadIn = document.querySelectorAll(".js-load-in");
// gsap.to(loadIn, 1, { 
//     autoAlpha: 1, 
//     ease: Power1.easeInOut 
// });


// if (typeof flickItems !== "undefined" && flickItems != null) {
//     letterFlick();
// }


//<-- Funcitons end

//Being rolled into lazyload by Guy
//This pauses videos on page refresh
//Ensures no flash of white
$(window).on("beforeunload", function () {
    //console.log('PAUSE VIDEO');
    $(".vidUnload").each(function () {
        $(this).get(0).pause();
    });
});